import React from 'react';
import './statcard.css';

const StatCard = ({ icon: Icon, label, value, color }) => {
  return (
    <div className="statCard">
      <div className="statCardIcon">{Icon && <Icon fontSize="large" />}</div>
      <div className="statCardLabel">{label}</div>
      <div className="statCardValue" style={{ color: color || '#333' }}>{value}</div>
    </div>
  );
};

export default StatCard;
